import { FiSearch } from 'react-icons/fi'
import { Like1 } from 'iconsax-react'
import Image from 'next/image'

const Index = () => {
  const questions = [
    {
      question:
        'You have a birthday cake and have exactly 3 slices to cut it into 8 equal pieces. How do you do it?',
      answers: [
        "Assuming the cake is square: slice 1: cut horizontally to create 2 equal pieces slice 2: cut vertically to create 4 equal pieces slice 3: line up all 4 pieces of cake side by side and cut horizontally to create 8 equal pieces. don't stack, it will ruin the frosting. Less",
        'Cut each slice into 3 slices. Then eat one of them.',
        'Slice it horizontally across the middle creating two equal halves top and bottom. Then simple two slice cross from above like normal.',
      ],
    },
    {
      question:
        'How did you design a performance management system? And was it successful? Why or why not?',
      answers: [
        "Assuming the cake is square: slice 1: cut horizontally to create 2 equal pieces slice 2: cut vertically to create 4 equal pieces slice 3: line up all 4 pieces of cake side by side and cut horizontally to create 8 equal pieces. don't stack, it will ruin the frosting. Less",
        'Cut each slice into 3 slices. Then eat one of them.',
        'Slice it horizontally across the middle creating two equal halves top and bottom. Then simple two slice cross from above like normal.',
      ],
    },
  ]

  // <Like1 size="32" color="#FF8A65" variant="Bulk"/>

  return (
    <div>
      <div className="sticky top-0 z-10 mb-10 flex h-56 w-full items-end bg-secondary p-6 px-16">
        <div className="mx-auto -mb-24 flex w-full max-w-[1500px] items-center justify-between rounded-lg bg-[#FFFFFF] shadow-lg ring-4 ring-gray-800 ring-offset-[-10px]">
          <div className="flex items-center space-x-7 p-4">
            <Image
              src="/assets/exploreArticles.png"
              alt="icon"
              width={90}
              height={90}
            />
            <div>
              <p className="text-3xl font-bold text-black">
                Interview Questions
              </p>
              <p className="font-light text-[#A6A6A6]">
                Read interview questions ahead of time so you can prep in time
              </p>
            </div>
          </div>

          <div className="flex w-[35rem] items-center gap-1 px-0 md:h-[70px] md:px-5">
            <div className="flex w-full items-center">
              <div className="flex h-[45px] w-full flex-row-reverse items-stretch gap-2">
                <input
                  type="text"
                  className="w-full rounded-md border-none bg-[#f0f0f0] px-4 font-WorkSans text-sm placeholder-[#A6A6A6] outline-none"
                  placeholder="Have a question in mind?"
                  // value={searchTerm}
                  // onChange={handleSearchChange}
                />
              </div>
            </div>
            <div className="hidden h-[45px] min-w-[45px] items-center justify-center bg-black text-center text-2xl text-white shadow-[3px_3px_0px_0px_#16BF44] transition duration-200 hover:bg-[#16BF44] hover:shadow-[-3px_3px_0px_0px_#191919] md:flex">
              <FiSearch />
            </div>
          </div>
        </div>
      </div>
      <div className='px-16 mb-10'>
        <div className="item-start mx-auto mt-36 flex max-w-[1500px] gap-14">
          {questions.map((question, index) => {
            return (
              <div key={index}>
                <p className="text-[16px] font-bold">{question.question}</p>
                <p className="text-[16px] text-[#A6A6A6]">
                  {question.answers.length} Answers
                </p>
                <div>
                  {question.answers.map((answer, index) => {
                    return (
                      <div
                        className="mt-4 flex items-start gap-4 rounded-md border border-[#EFEFEF] bg-[#FAFAFA] px-3 py-2"
                        key={index}
                      >
                        <div className="w-fit rounded-md bg-primary bg-opacity-10 p-4">
                          <Like1 size="24" color="#27AE60" variant="Bulk" />
                        </div>
                        <p>{answer}</p>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Index
